import { arePrimaryAndSecondaryEmailsEquivalent } from '@Common/validators/email_secondary_email';

import type { ExtraValidationResult, ValidateFunc } from '@sh4res/bo-common/components/StepperForm';
import { isProdEnv } from '@sh4res/bo-common/utils/env';

const EMAIL_SAME_AS_SECONDARY_EMAIL_MESSAGE =
  'resources.bo_common.b2b.employees.actions.edit.validation.email_same_as_secondary_email';

type EmployeeEmailFields = {
  email?: unknown;
  secondary_email?: unknown;
};

const normalizeEmailValue = (value: unknown) => (value === '' ? null : value);

export const validateEmployeeEmails = (
  emailFields: EmployeeEmailFields,
  record?: EmployeeEmailFields | null,
): ExtraValidationResult => {
  const email = normalizeEmailValue(emailFields.email);
  const secondary_email = normalizeEmailValue(emailFields.secondary_email);
  const recordEmail = normalizeEmailValue(record?.email);
  const recordSecondaryEmail = normalizeEmailValue(record?.secondary_email);

  const didChangePrimaryEmail = record ? email !== recordEmail : true;
  const didChangeSecondaryEmail = record ? secondary_email !== recordSecondaryEmail : true;

  const emailToCompare = didChangePrimaryEmail ? email : recordEmail;
  const secondaryEmailToCompare = didChangeSecondaryEmail ? secondary_email : recordSecondaryEmail;

  if (
    (didChangePrimaryEmail || didChangeSecondaryEmail) &&
    typeof emailToCompare === 'string' &&
    typeof secondaryEmailToCompare === 'string' &&
    arePrimaryAndSecondaryEmailsEquivalent(emailToCompare, secondaryEmailToCompare, {
      // Non-prod: allow plus-aliases so QA can receive real OTPs on distinct mailboxes.
      treatPlusAliasesAsSame: isProdEnv(),
    })
  ) {
    return {
      isValid: false,
      message: EMAIL_SAME_AS_SECONDARY_EMAIL_MESSAGE,
    };
  }

  return { isValid: true };
};

export const createEmployeeEmailsValidator =
  (record?: EmployeeEmailFields | null): ValidateFunc =>
  ({ getValues }) => {
    const { email, secondary_email } = getValues();

    return validateEmployeeEmails({ email, secondary_email }, record);
  };
